module.exports = __webpack_public_path__ + "img/44982054_1235562273266083_3948371999377588224_o.1c12ae4c.jpg";